import React, {useState, useEffect} from 'react';
import { useNavigate } from 'react-router-dom';
import './Classement.css'
import {classementAPI, listClubProam, listClubProbm, listClubProad, listClubProbd} from '../variables';

import axios from 'axios';
import LogoClub from '../components/LogoClub';
import PageHero from '../components/PageHero';

// Colonnes statistiques : clé API, en-tête, libellé complet, masquée sur mobile
const COLONNES = [
    {key: 'pts', label: 'Pts', title: 'Points'},
    {key: 'joue', label: 'MJ', title: 'Matchs joués'},
    {key: 'vic', label: 'V', title: 'Victoires'},
    {key: 'nul', label: 'N', title: 'Nuls'},
    {key: 'def', label: 'D', title: 'Défaites'},
    {key: 'pf', label: 'FF/P', title: 'Forfaits / Pénalités', desktop: true},
    {key: 'pg', label: 'PG', title: 'Parties gagnées', desktop: true},
    {key: 'pp', label: 'PP', title: 'Parties perdues', desktop: true},
];

function Classement({championnat}) {
    const navigate = useNavigate();
    const [classement, setClassement] = useState(null);

    useEffect(() => {
        getClassement()
    }, [championnat])

    const getClassement = async () => {
        const link = classementAPI.find(item => item.for === championnat).link;
        if (link !== '') {
            axios
            .get(link, {
                "Content-Type": "application/xml; charset=utf-8"
            })
            .then(function(res) {
                var data = res.data;
                // Trier les données par la position
                data.sort((a, b) => {
                    return a.clt - b.clt;
                });
                setClassement(data);
            })
            .catch(function(error) {
                console.log(error);
            });
        }
    }

    const info = (index, value) => {
        return classement[index][value];
    }

    const getCorrectListClub = (value) => {
        switch (value) {
            case 'proam':
                return listClubProam;
            case 'probm':
                return listClubProbm;
            case 'proad':
                return listClubProad;
            case 'probd':
                return listClubProbd;
            default:
                break;
        }
    }

    const getClub = (index) => {
        const identifier = info(index, 'numero');
        const title = info(index, 'equipe');
        const champ = getCorrectListClub(championnat) || null;

        if (champ !== null) {
            return champ.find(item => item.identifier === identifier || item.title.trim() === title.trim());
        }

        return "";
    }

    const getPositionClass = (index, length) => {
        switch (championnat) {
            case 'proam': /* Pro A Messieurs */
                if (index < 2) return 'montee';
                return '';
            case 'proad': /* Pro A Dames */
                if (index < 6) return 'montee';
                if (index >= length - 6) return 'descente';
                return '';
            case 'probm': /* Pro B Messieurs */
                if (index < 6) return 'montee';
                if (index >= length - 6) return 'descente';
                return '';
            case 'probd': /* Pro B Dames */
                if (index === 0) return 'montee';
                if (index === length - 1) return 'descente';
                return '';
            default:
                return '';
        }
    }

    const handleClubClick = (club) => {
        if (club && club.short) {
            navigate('/' + championnat + '/' + club.short, {state: {onglet: 1}});
        }
    }

    return (
        <div className={"classement_page " + championnat}>

            {/* // BANNIERE */}
            <PageHero championnat={championnat} title="Classement" />

            <div className="classement_content">
                <div className="classement_card">
                    <table className="classement_table">
                        <thead>
                            <tr>
                                <th className="classement_pos_head" title="Position">#</th>
                                <th className="classement_club_head">Club</th>
                                {
                                    COLONNES.map((col) => (
                                        <th key={col.key} title={col.title} className={col.desktop ? 'classement_desktop' : ''}>
                                            {col.label}
                                        </th>
                                    ))
                                }
                            </tr>
                        </thead>
                        <tbody>
                            {
                                classement !== null &&
                                classement.map((item, index) => {
                                    const club = getClub(index);
                                    const zone = getPositionClass(index, classement.length);
                                    return (
                                        <tr
                                            key={info(index, 'numero')}
                                            className={"classement_row " + zone + (club && club.short ? ' clickable' : '')}
                                            onClick={() => handleClubClick(club)}
                                        >
                                            <td>
                                                <span className={"classement_pos " + zone}>{info(index, 'clt')}</span>
                                            </td>
                                            <td>
                                                <div className="classement_club_cell">
                                                    <div className="cl_logo">
                                                        <LogoClub club={club} width="32" height="32" activateLink={false} />
                                                    </div>
                                                    <span className="classement_club">{info(index, 'equipe')}</span>
                                                </div>
                                            </td>
                                            {
                                                COLONNES.map((col) => (
                                                    <td
                                                        key={col.key}
                                                        className={"classement_scores" + (col.key === 'pts' ? ' classement_pts' : '') + (col.desktop ? ' classement_desktop' : '')}
                                                    >
                                                        {info(index, col.key)}
                                                    </td>
                                                ))
                                            }
                                        </tr>
                                    )
                                })
                            }
                        </tbody>
                    </table>
                </div>
                <div className="legend">
                    <div className="legend_item">
                        <span className="classement_pos montee legend_dot"></span>
                        <span>{championnat === 'probd' ? 'Montée' : 'Playoffs'}</span>
                    </div>
                    {
                        championnat !== 'proam' &&
                        <div className="legend_item">
                            <span className="classement_pos descente legend_dot"></span>
                            <span>{championnat === 'probd' ? 'Descente' : 'Playdown'}</span>
                        </div>
                    }
                    <div className="legend_abbr">
                        {COLONNES.map((col) => col.label + ' : ' + col.title).join(' · ')}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Classement;
